// @ts-nocheck -- legacy receiving contracts are migrated incrementally below.
import React, { useState } from "react";

import Input from "../../../../components/controls/Input";

export default function InvoiceRecordInventory(props) {
  const { invoiceDetails, onGenerateBarcodePdf } = props;

  const [createBarcodeInProgress, setCreateBarcodeInProgress] = useState(false);

  const generateBarcodeStringClicked = async function () {
    setCreateBarcodeInProgress(true);
    const callResult = await onGenerateBarcodePdf({
      receiving_item_id: invoiceDetails.receiving_item_id,
    });
    setCreateBarcodeInProgress(false);

    if (callResult.success) {
      setTimeout(() => {
        window.print();
      }, 1500);
    }
  };

  return (
    <div>
      <div className="mt-5 px-4 py-5 sm:p-2 grid grid-cols-1 overflow-hidden rounded-[18px] border border-[#E2E8F0] bg-white shadow-[0_1px_2px_rgba(15,23,42,0.04)] md:grid-cols-3">
        <div className="col-span-3">
          <h3 className="text-base font-semibold leading-6 text-[#0F172A]">
            Inventory details
          </h3>
        </div>

        <div className="mt-2 col-span-1">
          <Input
            label="Used Unit"
            name="used_weight"
            value={invoiceDetails.used_weight}
            labelOn={true}
            type="text"
            className="mt-1 block w-full border border-[#E2E8F0] rounded-xl shadow-sm py-2 px-3 focus:outline-none focus:ring-2 focus:border-[#2563EB] focus:ring-[#2563EB]/10 sm:text-sm"
          />
        </div>
        <div className="mt-2 ml-2 col-span-1">
          <Input
            label="In Stock"
            name="in_stock"
            value={invoiceDetails.in_stock}
            labelOn={true}
            type="text"
            className="mt-1 block w-full border border-[#E2E8F0] rounded-xl shadow-sm py-2 px-3 focus:outline-none focus:ring-2 focus:border-[#2563EB] focus:ring-[#2563EB]/10 sm:text-sm"
          />
        </div>
      </div>
      <div>
        <button
          type="button"
          className="mt-5 inline-flex items-center justify-center rounded-xl border border-[#E2E8F0] bg-white px-4 py-2 text-sm font-semibold text-[#0F172A] shadow-sm transition hover:border-[#2563EB] hover:bg-[#EFF6FF] hover:text-[#2563EB]"
          onClick={() => generateBarcodeStringClicked()}
        >
          {createBarcodeInProgress ? (
            <svg
              className="animate-spin -ml-1 mr-3 h-5 w-5 text-[#0F172A]"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
          ) : (
            "Print barcode"
          )}
        </button>
      </div>
    </div>
  );
}
